import { AgTechTourConfig } from '@agtech/web/components/App/Tour/AgTechTourTypes'

export const SalePlanningTasksPageTourConfig: AgTechTourConfig = {
    id: 'sale-planning-tasks-page-tour',
    name: 'Planning Tasks Tour',
    steps: [
        {
            targetId: 'sale-planning-tasks-grid',
            title: 'Planning Tasks',
            description: 'Track everything that needs to happen before and during this sale. Each task shows its priority, dates, completion status, and who it is assigned to. Use the row menu to assign, complete, reopen, or delete a task.',
            position: 'top',
        },
        {
            targetId: 'sale-planning-tasks-add-btn',
            skipIfMissing: true,
            title: 'Add a Task',
            description: 'Create a one-off planning task for this sale, set its priority and dates, and optionally assign it to a member of your team.',
            position: 'bottom',
        },
        {
            targetId: 'sale-planning-tasks-apply-template-btn',
            skipIfMissing: true,
            title: 'Apply a Task Template',
            description: 'Add a full set of tasks at once from a saved template. Templates are managed under Settings > Task Templates.',
            position: 'bottom',
        },
    ]
}
